const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const getBookingDateRange = (fromDate = new Date()) => {
  const start = startOfDay(fromDate);
  const end = new Date(start);
  end.setDate(end.getDate() + 30);
  return { start, end };
};

/** 5 weekday columns × 4 week rows, Mon-aligned */
export const getBookingCalendarGrid = (rangeStart, rangeEnd) => {
  const weekdayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  const rows = 4;
  const cols = 5;

  const calendarStart = startOfDay(rangeStart);
  const startDay = calendarStart.getDay();
  calendarStart.setDate(calendarStart.getDate() - (startDay === 0 ? 6 : startDay - 1));

  const grid = [];
  for (let row = 0; row < rows; row += 1) {
    const weekRow = [];
    for (let col = 0; col < cols; col += 1) {
      const date = new Date(calendarStart);
      date.setDate(calendarStart.getDate() + row * 7 + col);
      const isWeekday = date.getDay() >= 1 && date.getDay() <= 5;
      const inRange = date >= rangeStart && date <= rangeEnd;
      weekRow.push(isWeekday && inRange ? date : null);
    }
    grid.push(weekRow);
  }

  return { weekdayLabels, grid };
};

export const formatBookingDate = (date) =>
  date.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

export const formatBookingRangeLabel = (start, end) => {
  const opts = { day: 'numeric', month: 'short', year: 'numeric' };
  return `${start.toLocaleDateString('en-GB', opts)} – ${end.toLocaleDateString('en-GB', opts)}`;
};

export const getTimeSlots = () => {
  const slots = [];
  for (let minutes = 8 * 60; minutes <= 17 * 60 + 30; minutes += 30) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
  return slots;
};

export const toDateKey = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const isSameDay = (a, b) => a && b && toDateKey(a) === toDateKey(b);

export const isToday = (date) => isSameDay(date, startOfDay(new Date()));
